var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as R from "../libs/ramda";
import EventEmitter from "events";
import Record from "../Record";
var Model = /** @class */ (function (_super) {
    __extends(Model, _super);
    function Model(record) {
        if (record === void 0) { record = []; }
        var _this = _super.call(this) || this;
        _this.record = record.map(function (v, i) {
            return new Record(__assign({ id: i + 1 }, v));
        });
        setTimeout(function () {
            _this.trigger("created", {});
        }, 1);
        return _this;
    }
    Model.prototype.trigger = function (channel, args) {
        this.emit(channel, __assign(__assign({}, args), { target: this }));
    };
    Model.prototype.findIndex = function (id) {
        return R.findIndex(function (v) { return v.id === id; }, this.record);
    };
    Model.prototype.insert = function (_a) {
        var _b = _a.id, id = _b === void 0 ? this.length + 1 : _b, rest = __rest(_a, ["id"]);
        var row = new Record(__assign({ id: id }, rest));
        var res = R.insert(-1, row, this.record);
        this.record = res;
        this.trigger("inserted", { record: row });
        this.trigger("changed", { type: "inserted", record: row });
        return this;
    };
    Model.prototype.update = function (id, params) {
        var item = this.find(id);
        var row = __assign(__assign({}, item), params);
        var res = R.update(this.findIndex(id), row, this.record);
        this.record = res;
        this.trigger("updated", { record: row });
        this.trigger("changed", { type: "updated", record: row });
        return this;
    };
    Model.prototype.destroy = function (id) {
        var row = this.find(id);
        var res = R.remove(this.findIndex(id), 1, this.record);
        this.record = res;
        this.trigger("destroyed", { record: row });
        this.trigger("changed", { type: "destroyed", record: row });
        return this;
    };
    Model.prototype.truncate = function () {
        this.record = [];
        this.trigger("truncated", {});
        this.trigger("changed", { type: "truncated" });
        return this;
    };
    Model.prototype.find = function (id) {
        return R.find(function (v) { return v.id === id; })(this.record);
    };
    Model.prototype.findBy = function (key, value) {
        return R.find(function (v) { return v[key] === value; })(this.record);
    };
    Model.prototype.findAll = function (key, value) {
        return R.filter(function (v) { return v[key] === value; })(this.record);
    };
    Model.prototype.all = function () {
        return this.record;
    };
    Model.prototype.head = function () {
        return R.head(this.record);
    };
    Model.prototype.last = function () {
        return R.last(this.record);
    };
    Model.prototype.drop = function (count) {
        this.record = R.drop(count, this.record);
        return this.record;
    };
    Object.defineProperty(Model.prototype, "length", {
        get: function () {
            return this.record.length;
        },
        enumerable: false,
        configurable: true
    });
    Model.prototype.orderBy = function (key, direction) {
        if (direction === void 0) { direction = "asc"; }
        var res = R.sort(function (a, b) { return (direction === "asc" ? a[key] - b[key] : b[key] - a[key]); }, this.record);
        this.record = res;
        return this.record;
    };
    Model.prototype.paginate = function (count, limit) {
        if (limit === void 0) { limit = Infinity; }
        var offset = (count - 1) * limit;
        return R.pipe(R.slice(offset, Infinity), R.take(limit))(this.record);
    };
    return Model;
}(EventEmitter));
export default Model;
